import React, { useEffect, useRef, useState } from "react";
import { getCookie, setCookie } from "../VanillaJS/cookies";
import { translate } from "../Services/translation";
import { Svg } from "./Svg";

const cookieName = 'product-list-mode';
const MODES = Object.freeze({
    GRID: 'grid',
    LIST: 'list'
});

const GridListSwitcher = function({containerSelector}) {
    if (!containerSelector) return;

    const possibleStates = Object.freeze([...Object.values(MODES)]);
    let modeFromCookie = getCookie(cookieName);
    let validModeFromCookie = possibleStates.includes(modeFromCookie);
    if (!validModeFromCookie) {
        modeFromCookie = MODES.GRID;
        setCookie(cookieName, MODES.GRID,7);
    }

    /**
     * @type {[MODES, React.Dispatch<React.SetStateAction<Mode>>]}
     */
    const [mode, setMode] = useState(modeFromCookie || MODES.GRID);
    let containerRef = useRef(null);

    /**
     * @param {string|null} forceMode
     */
    const onClick = (forceMode = null) => {
        /**
         * @type {MODES}
         */
        let newState = forceMode || (mode === MODES.GRID ? MODES.LIST : MODES.GRID);
        setCookie(cookieName, newState,7);
        setContainerAttribute(newState);
        setMode(newState);
    }

    /**
     * Set attribtue on container element
     * @param {MODES} mode
     */
    const setContainerAttribute = (mode) => {
        if (!containerRef.current) return;
        containerRef.current.setAttribute("mode", mode)
    }

    useEffect(() => {
        containerRef.current = document.querySelector(containerSelector);
    }, []);

    return (
        <button type="button" onClick={() => onClick()} className="button button--outline-ocean product-list__mode-switcher">
            {mode === MODES.GRID ? (
                <>{translate('nmas.productlist.mode.list')}<Svg icon="list-view" /></>
            ) : (
                <>{translate('nmas.productlist.mode.grid')} <Svg icon="grid-view" /></>
            )}
        </button>
    );
}

export default GridListSwitcher;